module.exports = __webpack_public_path__ + "img/TheMix_cls_TT6_.96d39148.svg";